import { BX, resolve } from '../internal/global';
import { ajax } from './ajax';

/**
 * Batch loading and form sending: `BX.ajax.load`, the iframe submit, `prepareForm`, `submitAjax`
 * and `BX.ajax.FormData`.
 *
 * Transcribed from `core_ajax.js`. The serialization of `prepareForm` and `submitAjax` is what the
 * server-side handlers parse, quirks included - a `select-multiple` adds `undefined` to the rough
 * size, a `[]` name takes the next integer index - so it is kept as it was.
 *
 * `BX.ajax.FormData` is defined under another local name: inside this module `FormData` has to
 * keep meaning the browser's class, which `send()` instantiates.
 */

/*
arObs = [{
	url: url,
	type: html|script|json|css,
	callback: function
}]
*/
ajax.load = function(arObs: any, callback?: any): void
{
	if (!BX.type.isArray(arObs))
	{
		arObs = [arObs];
	}

	let cnt = 0;

	if (!BX.type.isFunction(callback))
	{
		callback = BX.DoNothing;
	}

	// `len` is assigned by the loop below; the handler runs after it
	let len = 0;
	const handler = function(this: any, data: any): void
	{
		if (BX.type.isFunction(this.callback))
		{
			this.callback(data);
		}

		if (++cnt >= len)
		{
			callback();
		}
	};

	let i = 0;
	for (i = 0, len = arObs.length; i < len; i++)
	{
		switch (arObs[i].type.toUpperCase())
		{
			case 'SCRIPT':
				BX.loadScript([arObs[i].url], BX.proxy(handler, arObs[i]));
				break;
			case 'CSS':
				BX.loadCSS([arObs[i].url]);

				if (++cnt >= len)
				{
					callback();
				}
				break;
			case 'JSON':
				BX.ajax.loadJSON(arObs[i].url, BX.proxy(handler, arObs[i]));
				break;

			default:
				BX.ajax.get(arObs[i].url, '', BX.proxy(handler, arObs[i]));
				break;
		}
	}
};

/* ajax form sending */
ajax.submit = function(obForm: any, callback: any): boolean
{
	if (!obForm.target)
	{
		if (obForm.BXFormTarget == null)
		{
			const frame_name = 'formTarget_' + Math.random();
			obForm.BXFormTarget = document.body.appendChild(BX.create('IFRAME', {
				props: {
					name: frame_name,
					id: frame_name,
					src: 'javascript:void(0)',
				},
				style: {
					display: 'none',
				},
			}));
		}

		obForm.target = obForm.BXFormTarget.name;
	}

	obForm.BXFormCallback = callback;
	BX.bind(obForm.BXFormTarget, 'load', BX.proxy(BX.ajax._submit_callback, obForm));

	BX.submit(obForm);

	return false;
};

ajax.submitComponentForm = function(obForm: any, container: any, bWait?: any): boolean
{
	if (!obForm.target)
	{
		if (obForm.BXFormTarget == null)
		{
			const frame_name = 'formTarget_' + Math.random();
			obForm.BXFormTarget = document.body.appendChild(BX.create('IFRAME', {
				props: {
					name: frame_name,
					id: frame_name,
					src: 'javascript:void(0)',
				},
				style: {
					display: 'none',
				},
			}));
		}

		obForm.target = obForm.BXFormTarget.name;
	}

	let w: any;
	if (bWait)
	{
		w = BX.showWait(container);
	}

	obForm.BXFormCallback = function(d: any): void
	{
		if (bWait)
		{
			BX.closeWait(w);
		}

		const callOnload = function(): void
		{
			const win = window as any;
			if (win.bxcompajaxframeonload)
			{
				setTimeout(() => {
					win.bxcompajaxframeonload();
					win.bxcompajaxframeonload = null;
				}, 10);
			}
		};

		resolve(container).innerHTML = d;
		BX.onCustomEvent('onAjaxSuccess', [null, null, callOnload]);
	};

	BX.bind(obForm.BXFormTarget, 'load', BX.proxy(BX.ajax._submit_callback, obForm));

	return true;
};

// func will be executed in form context
ajax._submit_callback = function(this: any): void
{
	//opera and IE8 triggers onload event even on empty iframe
	try
	{
		if (this.BXFormTarget.contentWindow.location.href.indexOf('http') != 0)
		{
			return;
		}
	}
	catch (e)
	{
		return;
	}

	if (this.BXFormCallback)
	{
		this.BXFormCallback(this.BXFormTarget.contentWindow.document.body.innerHTML);
	}

	BX.unbindAll(this.BXFormTarget);
};

ajax.prepareForm = function(obForm: any, data?: any): { data: any, filesCount: number, roughSize: number }
{
	data = (data ? data : {});
	let i;
	let ii;
	let el;
	const _data: any[] = [];
	const n = obForm.elements.length;
	let files = 0;
	let length = 0;
	if (obForm)
	{
		for (i = 0; i < n; i++)
		{
			el = obForm.elements[i];
			if (el.disabled)
			{
				continue;
			}

			if (!el.type)
			{
				continue;
			}

			switch (el.type.toLowerCase())
			{
				case 'text':
				case 'textarea':
				case 'password':
				case 'number':
				case 'hidden':
				case 'select-one':
					_data.push({ name: el.name, value: el.value });
					length += (el.name.length + el.value.length);
					break;
				case 'file':
					if (el.files)
					{
						for (ii = 0; ii < el.files.length; ii++)
						{
							files++;
							_data.push({ name: el.name, value: el.files[ii], file: true });
							length += el.files[ii].size;
						}
					}
					break;
				case 'radio':
				case 'checkbox':
					if (el.checked)
					{
						_data.push({ name: el.name, value: el.value });
						length += (el.name.length + el.value.length);
					}
					break;
				case 'select-multiple':
					for (let j = 0; j < el.options.length; j++)
					{
						if (el.options[j].selected)
						{
							_data.push({ name: el.name, value: el.options[j].value });
							length += (el.name.length + el.options[j].length);
						}
					}
					break;
				default:
					break;
			}
		}

		i = 0;
		length = 0;
		let current = data;
		let name;
		let rest;
		let pp;
		let tmpKey;

		while (i < _data.length)
		{
			const p = _data[i].name.indexOf('[');
			if (tmpKey)
			{
				current[_data[i].name] = {};
				current[_data[i].name][tmpKey.replace(/\[|\]/gi, '')] = _data[i].value;
				current = data;
				tmpKey = null;
				i++;
			}
			else if (p == -1)
			{
				current[_data[i].name] = _data[i].value;
				current = data;
				i++;
			}
			else
			{
				name = _data[i].name.substring(0, p);
				rest = _data[i].name.substring(p + 1);
				pp = rest.indexOf(']');

				if (pp == -1)
				{
					if (!current[name])
					{
						current[name] = [];
					}
					current = data;
					i++;
				}
				else if (pp == 0)
				{
					if (!current[name])
					{
						current[name] = [];
					}
					//No index specified - so take the next integer
					current = current[name];
					_data[i].name = '' + current.length;
					if (rest.substring(pp + 1).indexOf('[') === 0)
					{
						tmpKey = rest.substring(0, pp) + rest.substring(pp + 1);
					}
				}
				else
				{
					if (!current[name])
					{
						current[name] = {};
					}
					//Now index name becomes and name and we go deeper into the array
					current = current[name];
					_data[i].name = rest.substring(0, pp) + rest.substring(pp + 1);
				}
			}
		}
	}

	return { data, filesCount: files, roughSize: length };
};

ajax.submitAjax = function(obForm: any, config: any): void
{
	config = (config !== null && typeof config === 'object' ? config : {});
	config.url = (config.url || obForm.getAttribute('action'));

	const additionalData = (config.data || {});
	config.data = BX.ajax.prepareForm(obForm).data;
	for (const ii in additionalData)
	{
		if (additionalData.hasOwnProperty(ii))
		{
			config.data[ii] = additionalData[ii];
		}
	}

	if (!(window as any).FormData)
	{
		BX.ajax(config);
	}
	else
	{
		const isFile = function(item: any): boolean
		{
			const res = Object.prototype.toString.call(item);

			return (res == '[object File]' || res == '[object Blob]');
		};

		const appendToForm = function(fd: any, key: any, val: any): void
		{
			if (!!val && typeof val === 'object' && !isFile(val))
			{
				for (const ii in val)
				{
					if (val.hasOwnProperty(ii))
					{
						appendToForm(fd, (key == '' ? ii : key + '[' + ii + ']'), val[ii]);
					}
				}
			}
			else
			{
				fd.append(key, (val ? val : ''));
			}
		};

		const prepareData = function(arData: any): any
		{
			let data: any = {};
			if (arData != null)
			{
				if (typeof arData === 'object')
				{
					for (const i in arData)
					{
						if (arData.hasOwnProperty(i))
						{
							const name = BX.util.urlencode(i);
							if (typeof arData[i] === 'object' && arData[i].file !== true)
							{
								data[name] = prepareData(arData[i]);
							}
							else if (arData[i].file === true)
							{
								data[name] = arData[i].value;
							}
							else
							{
								data[name] = BX.util.urlencode(arData[i]);
							}
						}
					}
				}
				else
				{
					data = BX.util.urlencode(arData);
				}
			}

			return data;
		};

		const fd = new window.FormData();

		if (config.method !== 'POST')
		{
			config.data = BX.ajax.prepareData(config.data);
			if (config.data)
			{
				config.url += (config.url.indexOf('?') !== -1 ? '&' : '?') + config.data;
				config.data = '';
			}
		}
		else
		{
			if (config.preparePost === true)
			{
				config.data = prepareData(config.data);
			}
			appendToForm(fd, '', config.data);
			config.data = fd;
		}

		config.preparePost = false;
		config.start = false;

		const xhr = BX.ajax(config);
		if (config.onprogress)
		{
			xhr.upload.addEventListener(
				'progress',
				(e: any) => {
					let percent = null;
					if (e.lengthComputable && (e.total || e.totalSize))
					{
						percent = e.loaded * 100 / (e.total || e.totalSize);
					}
					config.onprogress(e, percent);
				},
			);
		}
		xhr.send(fd);
	}
};

const AjaxFormData = function(this: any): void
{
	this.elements = [];
	this.files = [];
	this.features = {};
	this.isSupported();
	this.log('BX FormData init');
} as any;

AjaxFormData.isSupported = function(): boolean
{
	let f = new BX.ajax.FormData();
	const result = f.features.supported;
	f = null;

	return result;
};

// The logging it once had was switched off for good; the method stays for its callers.
AjaxFormData.prototype.log = function(o: any): void
{};

AjaxFormData.prototype.isSupported = function(this: any): boolean
{
	const f: any = {};
	f.fileReader = (window.FileReader && window.FileReader.prototype.readAsBinaryString);
	f.readFormData = f.sendFormData = !!(window.FormData);
	f.supported = !!(f.readFormData && f.sendFormData);
	this.features = f;
	this.log('features:');
	this.log(f);

	return f.supported;
};

AjaxFormData.prototype.append = function(this: any, name: any, value: any): void
{
	if (typeof (value) === 'object')
	{ // seems to be files element
		this.files.push({ name, value });
	}
	else
	{
		this.elements.push({ name, value });
	}
};

AjaxFormData.prototype.send = function(
	this: any,
	url: any,
	callbackOk?: any,
	callbackProgress?: any,
	callbackError?: any,
): any
{
	this.log('FD send');
	this.xhr = BX.ajax({
		method: 'POST',
		dataType: 'html',
		url,
		onsuccess: callbackOk,
		onfailure: callbackError,
		start: false,
		preparePost: false,
	});

	if (callbackProgress)
	{
		this.xhr.upload.addEventListener(
			'progress',
			(e: any) => {
				if (e.lengthComputable)
				{
					callbackProgress(e.loaded / (e.total || e.totalSize));
				}
			},
			false,
		);
	}

	if (this.features.readFormData && this.features.sendFormData)
	{
		const fd = new FormData();
		this.log('use browser formdata');
		for (const i in this.elements)
		{
			if (this.elements.hasOwnProperty(i))
			{
				fd.append(this.elements[i].name, this.elements[i].value);
			}
		}

		for (const i in this.files)
		{
			if (this.files.hasOwnProperty(i))
			{
				fd.append(this.files[i].name, this.files[i].value);
			}
		}
		this.xhr.send(fd);
	}

	return this.xhr;
};

ajax.FormData = AjaxFormData;
